import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, MutableRefObject, useCallback, useRef } from 'react';
import {
  KeyboardTypeOptions,
  NativeSyntheticEvent,
  ReturnKeyTypeOptions,
  StyleProp,
  TextInput,
  TextInputProps,
  TextInputSubmitEditingEventData,
  TextStyle,
} from 'react-native';

export type FormInputProps = {
  placeholder?: string;
  multiline?: boolean;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
  value?: string;
  placeholderTextColor?: string;
  keyboardType?: KeyboardTypeOptions;
  returnKeyType?: ReturnKeyTypeOptions;
  returnKeyLabel?: string;
  isPassword?: boolean;
  bgColor?: string;
  autoFocus?: boolean;
  clearButtonMode?: TextInputProps['clearButtonMode'];
  inputRef?: MutableRefObject<TextInput | undefined>;
  onChange?: (value: string) => void;
  onSubmitEditing?: (
    e: NativeSyntheticEvent<TextInputSubmitEditingEventData>,
  ) => void;
};

export const FormInput = memo(
  ({
    bgColor = '#fff',
    placeholderTextColor,
    placeholder,
    multiline,
    numberOfLines,
    style,
    value,
    inputRef,
    keyboardType,
    returnKeyType,
    returnKeyLabel,
    clearButtonMode,
    isPassword,
    autoFocus,
    onChange,
    onSubmitEditing,
  }: FormInputProps) => {
    const { rpx } = useResponsiveContext();
    const ref = useRef<TextInput>();
    const onRef = useCallback(
      (r: any) => {
        ref.current = r;
        if (inputRef != null) {
          inputRef.current = r;
        }
      },
      [inputRef],
    );
    return (
      <TextInput
        ref={onRef}
        placeholder={placeholder}
        multiline={multiline}
        numberOfLines={numberOfLines}
        textAlignVertical={multiline ? 'top' : 'center'}
        placeholderTextColor={placeholderTextColor}
        keyboardType={keyboardType}
        secureTextEntry={isPassword}
        returnKeyType={returnKeyType}
        returnKeyLabel={returnKeyLabel}
        autoFocus={autoFocus}
        onSubmitEditing={onSubmitEditing}
        clearButtonMode={clearButtonMode}
        disableFullscreenUI
        css={`
          padding: 0 ${rpx(22)}px;
          border-radius: ${rpx(22)}px;
          height: ${rpx(44)}px;
          background-color: ${bgColor};
          font-family: ${FontFamily.NotoSans.Medium};
          color: #000;
        `}
        style={style}
        value={value ?? ''}
        onChangeText={onChange}
      />
    );
  },
);
